export const getters = {
  tiers(state) {
    return state.tiers;
  },

  filters(state) {
    return state.filters;
  },

  categories(state) {
    return state.categories;
  },

  collections(state) {
    return state.collections;
  },

  badges(state) {
    return state.badges;
  },

  details(state) {
    return state.details;
  },

  directorySettingsAreReady(state) {
    return state.details.directorySettings != null;
  },

  // Domains
  vendorCustomDomain(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    const { customDomain } = state.details.directorySettings;
    return customDomain ? stripTrailingSlash(customDomain) : null;
  },

  integrationsCustomDomain(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    const { integrationsCustomDomain } = state.details.directorySettings;
    return integrationsCustomDomain
      ? stripTrailingSlash(integrationsCustomDomain)
      : null;
  },

  genericDomain(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    const { partnerpageUrl } = state.details.directorySettings;
    return `https://${partnerpageUrl}.partnerpage.io`;
  },

  productionVendorDomain(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    return getters.vendorCustomDomain || getters.genericDomain;
  },

  productionIntegrationsDomain(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    return getters.integrationsCustomDomain || getters.genericDomain;
  },

  previewDomain(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    return getters.genericDomain;
  },

  // Base URLs
  agenciesDirectoryBaseUrl(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    const { directoryPage } = state.details.directorySettings;
    return directoryPage
      ? `${getters.productionVendorDomain}/${stripTrailingSlash(directoryPage)}`
      : getters.productionVendorDomain;
  },

  integrationsDirectoryBaseUrl(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    const { integrationsDirectoryPage } = state.details.directorySettings;
    return `${getters.productionIntegrationsDomain}/${stripTrailingSlash(
      integrationsDirectoryPage
    )}`;
  },

  // Get Listed URLs
  agenciesDirectoryGetListedUrl(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    return `${getters.agenciesDirectoryBaseUrl}/get-listed`;
  },

  integrationsDirectoryGetListedUrl(state, getters) {
    if (!getters.directorySettingsAreReady) return undefined;
    return `${getters.integrationsDirectoryBaseUrl}/get-listed`;
  },

  // Partner profile URL
  agenciesDirectoryPartnerUrlBuilder(state, getters) {
    return ({ slug }) => {
      if (!getters.directorySettingsAreReady) return undefined;
      return `${getters.agenciesDirectoryBaseUrl}/${slug}`;
    };
  },

  integrationsDirectoryPartnerUrlBuilder(state, getters) {
    return ({ slug }) => {
      if (!getters.directorySettingsAreReady) return undefined;
      return `${getters.integrationsDirectoryBaseUrl}/${slug}`;
    };
  },

  // Partner profile preview URL builders
  agenciesDirectoryPartnerPreviewUrlBuilder(state, getters) {
    return ({ slug, id }) => {
      if (!getters.directorySettingsAreReady) return undefined;
      const { directoryPage } = state.details.directorySettings;
      if (directoryPage) {
        return `${getters.previewDomain}/${stripTrailingSlash(
          directoryPage
        )}/preview/${slug}/${id}`;
      } else {
        return `${getters.previewDomain}/preview/${slug}/${id}`;
      }
    };
  },

  integrationsDirectoryPartnerPreviewUrlBuilder(state, getters) {
    return ({ slug, id }) => {
      if (!getters.directorySettingsAreReady) return undefined;
      const { integrationsDirectoryPage } = state.details.directorySettings;
      if (integrationsDirectoryPage) {
        return `${getters.previewDomain}/${stripTrailingSlash(
          integrationsDirectoryPage
        )}/preview/${slug}/${id}`;
      } else {
        return `${getters.previewDomain}/preview/${slug}/${id}`;
      }
    };
  },
};

export const removeDoubleBackslash = url => {
  const index = url.indexOf('//', 8); // starting an 8 to ignore https:// match. All of our URLs contain either http:// or https://
  if (index !== -1) {
    const result = url.slice(0, index + 1) + url.slice(index + 2, url.length);
    return removeDoubleBackslash(result);
  }
  return url;
};

function stripTrailingSlash(url) {
  return url.substr(-1) === '/' ? url.substr(0, url.length - 1) : url;
}
